export default "__VITE_ASSET__C_piwhB8__"